import React, { useEffect } from "react";
import Tabs from "./TabComponents/Tabs";
import Profile from "../Profile";
import PrimaryWheel from "../PrimaryWheel";

import { getLoggedInUser } from "../../../utils/helpers";
import { useDispatch, useSelector } from "react-redux";
import {
  selectPrimaryWheel,
  selectProfile,
  setProfile,
} from "../../../redux/reducers/gallery";
import { useParams } from "react-router-dom";
import { Box, Stack } from "@mui/material";
import {
  GradientContainer,
  IconContainer,
  NoDataContainer,
  StyledText,
  TextContainer,
} from "./styles";
import WheelIcon from "../../../assets/images/hidden-gallery.svg";
import HatIcon from "../../../assets/images/hat.svg";
import GlassesIcon from "../../../assets/images/glasses.svg";
import Button from "../../Button";
import { useNavigate } from "react-router-dom";
import _ from "lodash";

const WheelListing = ({
  wheelUpdatedDataSorted,
  profileData,
  isFetching,
  primaryWheelData,
  primaryWheelLoading,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const primaryWheel = useSelector(selectPrimaryWheel);
  const profile = useSelector(selectProfile);
  const userId = getLoggedInUser()?.id;
  const { id } = useParams();

  // profileData and isFetching are now passed as props from Gallery

  useEffect(() => {
    if (profileData) {
      dispatch(setProfile(profileData?.data));
    }
  }, [profileData, dispatch]);

  const showData = () => {
    if (profileData?.data?.visibility === "PUBLIC" || userId == id) {
      return true;
    }
    if (
      profileData?.data?.visibility === "PRIVATE" &&
      !_.isEmpty(profileData?.data)
    ) {
      return true;
    }

    return false;
  };

  return (
    <Stack sx={{ height: "100%" }}>
      {!isFetching ? (
        showData() ? (
          <>
            <Stack gap={2} direction="row" sx={{ height: "240px" }}>
              <Box
                sx={{
                  flex: 1,
                  height: "100%",
                  borderRadius: 2,
                  border: "1px solid #BBBBBB",
                  overflow: "hidden",
                }}
              >
                <Profile
                  data={profile}
                  wheelUpdatedDataSorted={wheelUpdatedDataSorted}
                />
              </Box>

              {id && (
                <Box
                  sx={{
                    flex: 1,
                    height: "100%",
                    borderRadius: 2,
                    border: "2px solid #BBBBBB",
                    overflow: "hidden",
                  }}
                >
                  <PrimaryWheel
                    userId={id}
                    data={primaryWheel}
                    primaryWheelData={primaryWheelData}
                    isLoading={primaryWheelLoading}
                  />
                </Box>
              )}
            </Stack>
            <Tabs />
          </>
        ) : (
          <GradientContainer>
            <NoDataContainer>
              <IconContainer>
                <img src={WheelIcon} alt="hidden" />
                <img
                  src={HatIcon}
                  alt="hat"
                  style={{ position: "absolute", right: "5px" }}
                />
                <img
                  src={GlassesIcon}
                  alt="glasses"
                  style={{ position: "absolute", right: "0px", top: "45px" }}
                />
              </IconContainer>

              <TextContainer>
                <StyledText>Oops! Nothing to see here!</StyledText>
                <Button
                  variant="outlined"
                  style={{ width: "72px", fontSize: "12px" }}
                  onClick={() => navigate(`/gallery/${userId}`)}
                >
                  Go Back
                </Button>
              </TextContainer>
            </NoDataContainer>
          </GradientContainer>
        )
      ) : null}
    </Stack>
  );
};

export default WheelListing;
